import { Link } from "react-router-dom";
import * as C from './styles.js';
import { HandleLogout } from "../../../logout/index.js";

export default function Menu({ profile, showModal, setShowModal }) {

    return(
        <C.Container className={`${showModal && 'showModal'}`} onMouseEnter={()=>setShowModal(true)} onMouseLeave={()=>setShowModal(false)}>
            <C.Content>
                <Link>
                    <img src={profile?.profile_photo_url} alt='usuario' onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src="https://dflix.netlify.app/imagens/img-avatar.png";}}/>
                    <span>{profile?.profile_name}</span>
                </Link>
                <Link to={`/configuracoes/principal`} onClick={()=>setShowModal(false)}>
                    <i className="fa-solid fa-gear"></i>
                    <span>Configurações</span>
                </Link>
                <Link to={`/profiles/`} onClick={()=>setShowModal(false)}>
                    <i className="fa-solid fa-repeat"></i>
                    <span>Trocar de perfil</span>
                </Link>
                <HandleLogout />
            </C.Content>
        </C.Container>
    )
}